module.exports = __webpack_public_path__ + "static/img/职业教育.1b600d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/职业教育.png
// module id = lK+N
// module chunks = 1